import api from './index';

export const ConversationsAPI = {
  getTwilioConversationsToken: (): Promise<any> => api.get('/conversation/token')
};
